<div class="mx-12 my-8 flex items-center">
    @if (section().path != null) {
        <a
            class="flex size-full items-center overflow-hidden rounded-4 py-8 hover:bg-surface-100 hover:text-text"
            [attr.aria-current]="selected() ? 'page' : null"
            [attr.aria-label]="
                expanded() ? undefined : (section().label | translate)
            "
            [attr.data-testid]="section().testId"
            [ngClass]="{ 'text-text-mid-contrast': !selected() }"
            [routerLink]="[section().path]"
        >
            <ng-container *ngTemplateOutlet="buttonSection" />
        </a>
    } @else {
        <!-- button used when path is null or when section has an advanced sidebar-->
        @if (disabled()) {
            <div
                class="flex w-max items-center text-text-mid-contrast"
                [attr.data-testid]="section().testId"
            >
                <ng-container *ngTemplateOutlet="sectionContent" />
            </div>
        } @else {
            <button
                class="flex size-full items-center justify-start overflow-hidden rounded-4 py-8 hover:bg-surface-100 hover:text-text"
                type="button"
                [attr.aria-controls]="
                    advancedSidebar() ? advancedSidebarControlsId() : null
                "
                [attr.aria-current]="selected() ? 'page' : null"
                [attr.aria-expanded]="
                    advancedSidebar() ? advancedSidebarOpen() : null
                "
                [attr.aria-haspopup]="advancedSidebar() ? 'true' : null"
                [attr.aria-label]="
                    expanded() ? undefined : (section().label | translate)
                "
                [attr.data-testid]="section().testId"
                [id]="id()"
                [ngClass]="{ 'text-text-mid-contrast': !selected() }"
                (click)="selectSection(section())"
            >
                <ng-container *ngTemplateOutlet="sectionContent" />
            </button>
        }

        <ng-template #sectionContent>
            <ng-container *ngTemplateOutlet="buttonSection" />
            @if (expanded() && advancedSidebar()) {
                <interacta-icon
                    class="size-24 shrink-0 transition-opacity duration-300"
                    [icon]="'chevron-small-right'"
                    [ngClass]="{
                        'opacity-0': !expanded(),
                        'opacity-100': expanded(),
                        'text-text-primary': selected(),
                    }"
                />
            }
        </ng-template>
    }
</div>

<ng-template #buttonSection>
    @if (section().icon; as icon) {
        <interacta-icon
            class="mx-8 size-24 shrink-0 overflow-hidden rounded-4 transition-colors duration-300"
            [icon]="icon | filledIcon: selected()"
            [matTooltip]="section().label | translate"
            [matTooltipDisabled]="expanded()"
            [matTooltipPosition]="'right'"
            [ngClass]="{
                'text-text-primary': selected(),
                'order-first': section().iconPosition === 'left',
            }"
        />
    }

    <span
        class="line-clamp-1 overflow-hidden text-left typo-medium-bold transition-all duration-300"
        [ngClass]="{
            'text-text': selected(),
            'opacity-0': !expanded(),
            'opacity-100': expanded(),
        }"
    >
        {{ section().label | translate }}</span
    >

    @if (newSection()) {
        <span
            class="mt-2 ml-8 rounded-3xl bg-surface-primary-low-contrast px-8 py-2 typo-xs-bold"
            >{{ 'SIDEBAR.NEW_SECTION_BADGE' | translate }}</span
        >
    }
</ng-template>
